(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tb-fabrica"] && !Shopify.designMode) return;
  try {
    
(() => {
  if (customElements.get('tb-fabrica')) return;
  class TbFabrica extends HTMLElement {
    connectedCallback() {
      this.querySelectorAll('[data-tb-src]').forEach((b) => b.addEventListener('click', () => this.tocar(b)));
      const faixa = this.querySelector('[data-tb-faixa]');
      const pontos = [...this.querySelectorAll('[data-tb-ponto]')];
      if (!faixa || !pontos.length) return;
      const marcar = () => {
        const cards = [...faixa.children];
        let i = 0;
        cards.forEach((el, k) => { if (el.offsetLeft - faixa.offsetLeft <= faixa.scrollLeft + 10) i = k; });
        if (faixa.scrollLeft + faixa.clientWidth >= faixa.scrollWidth - 2) i = cards.length - 1;
        pontos.forEach((p, k) => p.classList.toggle('is-atual', k === i));
      };
      faixa.addEventListener('scroll', marcar, { passive: true });
      pontos.forEach((p, k) => p.addEventListener('click', () => {
        const alvo = faixa.children[k];
        if (alvo) faixa.scrollTo({ left: alvo.offsetLeft - faixa.offsetLeft - 20, behavior: 'smooth' });
      }));
    }
    /* Troca a capa pelo vídeo, ali mesmo, e já começa a tocar. */
    tocar(botao) {
      if (!botao.dataset.tbSrc) return;
      const video = document.createElement('video');
      video.className = 'tb-fabrica__video';
      video.src = (botao.dataset.tbHls && video.canPlayType('application/vnd.apple.mpegurl')) ? botao.dataset.tbHls : botao.dataset.tbSrc;
      if (botao.dataset.tbCapa) video.poster = botao.dataset.tbCapa;
      video.controls = true;
      video.playsInline = true;
      video.setAttribute('playsinline', '');
      video.preload = 'auto';
      video.setAttribute('aria-label', botao.getAttribute('aria-label') || 'Vídeo');
      /* Só um vídeo por vez na página: o anterior volta para a capa e PARA de baixar (libera a internet para o novo). */
      const ant = window.tbVideoAtivo;
      if (ant && ant.video !== video) {
        try { ant.video.pause(); ant.video.removeAttribute('src'); ant.video.load(); } catch (e) {}
        if (ant.video.isConnected) ant.video.replaceWith(ant.botao);
      }
      window.tbVideoAtivo = { video, botao };
      botao.replaceWith(video);
      const p = video.play();
      if (p && p.catch) p.catch(() => {});
    }
  }
  customElements.define('tb-fabrica', TbFabrica);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tb-videos"] && !Shopify.designMode) return;
  try {
    
(() => {
  if (customElements.get('tb-videos')) return;
  class TbVideos extends HTMLElement {
    connectedCallback() {
      try { this.dados = JSON.parse(this.querySelector('[data-tb-videos-dados]').textContent); } catch (e) { this.dados = []; }
      this.trilho = this.querySelector('[data-tb-trilho]');
      this.querySelectorAll('[data-tb-abrir]').forEach((b) => b.addEventListener('click', () => this.tocar(b)));
      this.querySelectorAll('[data-tb-seta]').forEach((b) => b.addEventListener('click', () => this.rolar(Number(b.dataset.tbSeta))));
      this.ajustarSetas();
      window.addEventListener('resize', () => this.ajustarSetas());
      this.trilho.addEventListener('scroll', () => this.atualizarSetas(), { passive: true });
      this.faixa = this.querySelector('[data-tb-faixa]');
      const pontos = [...this.querySelectorAll('[data-tb-ponto]')];
      if (this.faixa && pontos.length) {
        const marcar = () => {
          const cards = [...this.faixa.children];
          let i = 0;
          cards.forEach((el, k) => { if (el.offsetLeft - this.faixa.offsetLeft <= this.faixa.scrollLeft + 10) i = k; });
          if (this.faixa.scrollLeft + this.faixa.clientWidth >= this.faixa.scrollWidth - 2) i = cards.length - 1;
          pontos.forEach((p, k) => p.classList.toggle('is-atual', k === i));
        };
        this.faixa.addEventListener('scroll', marcar, { passive: true });
        pontos.forEach((p, k) => p.addEventListener('click', () => {
          const alvo = this.faixa.children[k];
          if (alvo) this.faixa.scrollTo({ left: alvo.offsetLeft - this.faixa.offsetLeft - 20, behavior: 'smooth' });
        }));
      }
    }
    /* Troca a capa pelo vídeo, ali mesmo, e já começa a tocar com som. */
    tocar(botao) {
      const v = this.dados[Number(botao.dataset.tbAbrir)];
      if (!v || !v.src) return;
      const video = document.createElement('video');
      video.className = 'tb-videos__video';
      video.src = (v.hls && video.canPlayType('application/vnd.apple.mpegurl')) ? v.hls : v.src;
      if (v.capa) video.poster = v.capa;
      video.controls = true;
      video.playsInline = true;
      video.setAttribute('playsinline', '');
      video.preload = 'auto';
      video.setAttribute('aria-label', v.titulo);
      /* Só um vídeo por vez na página: o anterior volta para a capa e PARA de baixar (libera a internet para o novo). */
      const ant = window.tbVideoAtivo;
      if (ant && ant.video !== video) {
        try { ant.video.pause(); ant.video.removeAttribute('src'); ant.video.load(); } catch (e) {}
        if (ant.video.isConnected) ant.video.replaceWith(ant.botao);
      }
      window.tbVideoAtivo = { video, botao };
      botao.replaceWith(video);
      const p = video.play();
      if (p && p.catch) p.catch(() => {});
    }
    itens() { return [...this.trilho.querySelectorAll('.tb-videos__item')]; }
    ajustarSetas() {
      const sobra = this.trilho.scrollWidth > this.trilho.clientWidth + 2;
      this.trilho.classList.toggle('is-rolando', sobra);
      this.querySelectorAll('[data-tb-seta]').forEach((b) => { b.hidden = !sobra; });
      this.atualizarSetas();
    }
    indiceVisivel() {
      const x = this.trilho.scrollLeft;
      let i = 0;
      this.itens().forEach((el, k) => { if (el.offsetLeft - this.trilho.offsetLeft <= x + 10) i = k; });
      return i;
    }
    atualizarSetas() {
      const [ant, prox] = this.querySelectorAll('[data-tb-seta]');
      if (ant) ant.disabled = this.trilho.scrollLeft <= 2;
      if (prox) prox.disabled = this.trilho.scrollLeft + this.trilho.clientWidth >= this.trilho.scrollWidth - 2;
    }
    rolar(dir) {
      const lista = this.itens();
      const alvo = lista[Math.max(0, Math.min(lista.length - 1, this.indiceVisivel() + dir))];
      if (alvo) this.trilho.scrollTo({ left: alvo.offsetLeft - this.trilho.offsetLeft, behavior: 'smooth' });
    }
  }
  customElements.define('tb-videos', TbVideos);
})();

  } catch(e) { console.error(e); }
})();
})();
